import { css } from '@onbeam/business-styled-system/css';
import {
  AiIcon,
  CommunityIcon,
  NodesIcon,
  TechToolIcon,
} from '@onbeam/icons/business';

export const targetItems = [
  {
    title: 'Tech & infrastructure',
    icon: TechToolIcon,
    iconClassName: css({ color: 'blue.primary' }),
  },
  {
    title: 'Research & ecosystem growth',
    icon: NodesIcon,
    iconClassName: css({ color: 'yellow.primary' }),
  },
  {
    title: 'DeFi, RWA, AI & Gaming protocols',
    icon: AiIcon,
    iconClassName: css({ color: 'green.primary' }),
  },
  {
    title: 'Content & community projects',
    icon: CommunityIcon,
    iconClassName: css({ color: 'red.primary' }),
  },
];
